import { Button, Divider } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import AdmissionForm from "../../../components/FormGenerator/AdmissionForm";
import CentreForm from "../../../components/FormGenerator/CentreForm";

const CreateCentre = () => {
  const router = useHistory();
  const submit = () => {
    //   todo
  };
  return (
    <div className="dashboard-child">
      <div className="db-child-header">
        <h2>Create a new centre</h2>
        <Button
          onClick={() => router?.push("/dashboard/centres")}
          type="primary"
        >
          Go back
        </Button>
      </div>
      <Divider />
      <CentreForm />
    </div>
  );
};

export default CreateCentre;
